<template>
    <div class="main-box">
        <div class="box-header">
            <div class="portrait">
                <img :src="$store.state.user.buyerImage" alt="">
            </div>
            <div class="user-name">
                {{$store.state.user.buyer}}
            </div>
        </div>
        <div class="box-content">
            <scroll-wrap>
                <div class="box-content-wrap">
                    <div class="title">
                        Order History
                    </div>
                    <div class="order-list" v-if="buyerOrders.list.length>0">
                        <div class="order-item" v-for="(order,orderindex) in buyerOrders.list" :key="orderindex">
                            <div class="order-placed">
                                Order placed: {{ order.createTime | dateFilter }}
                            </div>
                            <div class="order-product-list">
                                <div class="product" v-for="(product,productindex) in order.product"
                                     :key="productindex">
                                    <div class="product-img">
                                        <img :src="product.image" alt="">
                                    </div>
                                    <div class="product-status">
                                        <div class="status">
                                            <span v-if="order.status===1">
                                                Paying on {{ order.paymentTime | dateFilter }}
                                            </span>
                                            <span v-if="order.status===2">
                                                Arriving By {{ order.deliveryTime | dateFilter }}
                                            </span>
                                            <span v-if="order.status===3">Complete order</span>
                                            <span v-if="order.status===4.1">
                                                Apply for refund on {{ order.applyTime | dateFilter }}
                                            </span>
                                            <span v-if="order.status===4.2">
                                                Refunded, transaction closed
                                            </span>
                                            <span v-if="order.status===5">
                                                Refunding on {{ order.applyTime | dateFilter }}
                                            </span>
                                            <span v-if="order.status===5.1">
                                                Return Request on {{ order.applyTime | dateFilter }}
                                            </span>
                                            <span v-if="order.status===5.2">
                                                Seller agrees to return on {{ order.applyTime | dateFilter }}
                                            </span>
                                            <span v-if="order.status===5.3">
                                                Shipped and Waiting for seller to receive goods
                                            </span>
                                            <span v-if="order.status===5.4">
                                                Refunded, transaction closed
                                            </span>
                                        </div>
                                        <div class="order-total">
                                            <span>
                                                Item Total:{{order.productFee}}
                                            </span>
                                            <span>
                                                Shipping Total:{{order.logisticsFee}}
                                            </span>
                                            <span>
                                                Order Total:{{order.actualFee}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="product-detail">
                                        <i class="el-icon-arrow-right"
                                           @click="productDetail=product;productDetailShow=true"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="order-handle">
                                <span class="btnn" v-if="order.status===2" @click="affirmData={show:true,order:order}">
                                    Confirm Receipt
                                </span>
                                <span class="btnn" v-if="order.status === 1.0 || order.status === 2.0 "
                                      @click="refundData = {show:true,order:order}">
                                    {{order.status===1.0?'Refund':'Return'}}
                                </span>
                                <span class="btnn" v-if="order.status === 5.2"
                                      @click="Object.assign(logisticsData,{show:true,order:order})">
                                    Logistics
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-else style="display: flex;align-items: center;justify-content: center;background: #FFFFFF;height: 80px">
                        暂无交易记录
                    </div>
                </div>
            </scroll-wrap>
            <div class="message-alert">

            </div>
        </div>
        <div class="box-footer">
            <div class="menu-item" @click="$emit('componentIndex',0)">
                <i class="iconfont iconshouye"></i>
                <span>Home</span>
            </div>
            <div class="menu-item" @click="$emit('componentIndex',1)">
                <i class="iconfont icongouwuche"></i>
                <span>Cart</span>
            </div>
            <div class="menu-item" @click="$emit('componentIndex',2)">
                <i class="iconfont iconxiaoxi"></i>
                <span>Service</span>
            </div>
            <div class="menu-item active" @click="$emit('componentIndex',3)">
                <i class="iconfont iconwode"></i>
                <span>My</span>
            </div>
        </div>
        <order-history-detail v-if="productDetailShow" :product-detail="productDetail"
                              @close="productDetailShow=false"></order-history-detail>
        <phone-affirm v-if="affirmData.show" @close="affirmData.show = false"
                      :data="affirmData">
            <template slot="content">
                <div style="display: flex;justify-content: center;flex-wrap: wrap">
                        <span v-for="(item,index) in affirmData.order.product" :key="index"
                              style="width: 60px;height: 60px;margin-right: 2px;margin-bottom: 2px">
                            <img :src="item.image" alt="" style="object-fit: cover" width="100%" height="100%">
                        </span>
                </div>
                <div style="font-size: 14px;font-weight: bolder;margin: 10px 0">
                    Confirm that the goods have been received ?
                </div>
            </template>
            <template slot="footer">
                <span @click="affirmReceipt">
                    Confirm Receipt
                </span>
            </template>
        </phone-affirm>
        <phone-affirm v-if="refundData.show" @close="refundData.show = false" :data="affirmData">
            <template slot="content">
                <div style="display: flex;justify-content: center;flex-wrap: wrap">
                        <span v-for="(item,index) in refundData.order.product" :key="index"
                              style="width: 60px;height: 60px;margin-right: 2px;margin-bottom: 2px">
                            <img :src="item.image" alt="" style="object-fit: cover" width="100%" height="100%">
                        </span>
                </div>
                <div style="font-size: 14px;font-weight: bolder;margin: 10px 0">
                    Are you sure you need to {{refundData.order.status===1.0?'Refund':'Return'}} it ?
                </div>
            </template>
            <template slot="footer">
                <span @click="affirmRefund">
                    Confirm Refund
                </span>
                <span @click="refundData.show = false" style="background: none;color:#00BCD4">
                    Cancel
                </span>
            </template>
        </phone-affirm>
        <phone-affirm v-if="logisticsData.show" @close="logisticsData.show = false" :data="logisticsData">
            <template slot="content">
                <div style="display: flex;justify-content: center;flex-wrap: wrap">
                        <span v-for="(item,index) in logisticsData.order.product" :key="index"
                              style="width: 60px;height: 60px;margin-right: 2px;margin-bottom: 2px">
                            <img :src="item.image" alt="" style="object-fit: cover" width="100%" height="100%">
                        </span>
                </div>
                <div style="font-size: 14px;font-weight: bolder;margin: 10px 0;text-align: center">
                    Fill in logistics information?
                </div>
                <div style="display: flex;flex-direction: column;font-size: 14px;margin-bottom: 8px;word-break: break-all;" v-if="logisticsData.order.logistics[1]">
                    <span>
                        Addressee：{{logisticsData.order.logistics[1].receiptName}}
                    </span>
                    <span>
                        Address：{{logisticsData.order.logistics[1].receipt}}
                    </span>
                    <span>
                        Phone：{{logisticsData.order.logistics[1].receiptPhone}}
                    </span>
                    <span>
                        Postal Code：{{logisticsData.order.logistics[1].receiptCode}}
                    </span>
                </div>
                <div>
                    <input v-model="logisticsData.data.logisticsType" placeholder="物流类型" type="text" style="border:1px solid #ABD5DB;border-radius:5px;outline: none;width: 100%;line-height: 26px;margin-bottom: 4px;font-size: 12px;padding: 0 10px;box-sizing: border-box" title="物流类型">
                    <input v-model="logisticsData.data.logisticsNo" placeholder="物流编号" type="text" style="border:1px solid #ABD5DB;border-radius:5px;outline: none;width: 100%;line-height: 26px;font-size: 12px;margin-bottom: 8px;padding: 0 10px;box-sizing: border-box" title="物流编号">
                </div>
            </template>
            <template slot="footer">
                <span @click="affirmLogistics">
                    Confirm Logistics
                </span>
                <span @click="logisticsData.show=false" style="background: none;color:#00BCD4">
                    Cancel
                </span>
            </template>
        </phone-affirm>
    </div>
</template>

<script>
    import OrderHistoryDetail from "./OrderHistoryDetail"
    import PhoneAffirm from "./PhoneAffirm"

    export default {
        name: "My-Detail",
        components: {
            OrderHistoryDetail,
            PhoneAffirm
        },
        data() {
            return {
                orderList: [],
                activeName: '',
                productDetail: {},
                productDetailShow: false,
                affirmData: {
                    show: false,
                    order: {}
                },
                refundData: {
                    show: false,
                    order: {}
                },
                logisticsData:{
                    show:false,
                    data:{
                        logisticsType:'',
                        logisticsNo:''
                    },
                    order:{}
                }
            }
        },
        computed: {
            buyerOrders: function () {
                return this.$store.state.buyerOrders
            }
        },
        filters: {
            dateFilter: function (value) {
                try {
                    let $value = new Date(value).toString().split(' ')
                    return `${$value[0]} ${$value[1]} ${$value[2]} ${$value[3]} ${$value[4]}`
                } catch (e) {
                    console.log(e)
                }
            }
        },
        created() {
            this.$store.dispatch('getBuyerList')
        },
        methods: {
            affirmLogistics(){
                this.axios.post('/student/order/buyer/delivery', {
                    id:this.logisticsData.order.id,
                    ...this.logisticsData.data
                }).then(res => {
                    if (res.succeed) {
                        this.$store.dispatch('getBuyerList');
                        this.logisticsData.show = false
                    }
                })
            },
            affirmReceipt() {
                this.axios.post('/student/order/buyer/confirm', {
                    orders: [
                        {
                            id: this.affirmData.order.id
                        }
                    ]
                }).then(res => {
                    if (res.succeed) {
                        this.$store.dispatch('getBuyerList');
                        this.affirmData.show = false
                    }
                })
            },
            affirmRefund() {
                this.axios.post('/student/order/buyer/apply', {
                    id:this.refundData.order.id,
                    returnApply:'123'
                }).then(res => {
                    if (res.succeed) {
                        this.$store.dispatch('getBuyerList');
                        this.refundData.show = false
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    div.main-box {
        position: relative;
        overflow: hidden;
        border-radius: 0 0 20px 20px;

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            opacity: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: -1;
            border-radius: 0 0 20px 20px;
            transition: z-index 0s linear 0.3s, opacity 0.3s linear;
        }

        &.mask-layer:before {
            transition: z-index 0s linear 0s;
            opacity: 1;
            z-index: 9998;
        }

        div.box-header {
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 88px;
            line-height: 88px;
            padding: 0 20px;

            > .portrait {
                width: 66px;
                height: 66px;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 20px;

                > img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            > .user-name {
                font-size: 18px;
                color: #000000;
                font-weight: bolder;
            }
        }

        div.box-content {
            position: relative;
            height: calc(100% - 140px);
            background: #edf6f9;

            div.box-content-wrap {
                div.title {
                    padding: 12px;
                    font-size: 14px;
                    font-weight: bolder;
                }

                div.order-list {
                    background: #FFFFFF;

                    div.order-item {
                        border-bottom: 1px solid #eeeeee;
                        padding: 12px;

                        div.order-placed {
                            color: #ffffff;
                            font-size: 14px;
                            margin-bottom: 10px;
                            background: #1e9595;
                            padding: 4px 12px;
                            border-radius: 4px;
                        }

                        div.order-product-list {
                            div.product {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;

                                div.product-img {
                                    width: 56px;
                                    height: 56px;
                                    flex-shrink: 0;

                                    > img {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }

                                div.product-status {
                                    margin-top: 10px;
                                    padding: 0 20px;
                                    flex-shrink: 1;

                                    div.status {
                                        font-size: 14px;
                                        font-weight: bolder;
                                        margin-bottom: 3px;
                                    }

                                    div.order-total {
                                        display: flex;
                                        flex-direction: column;

                                        > span {
                                            font-size: 12px;
                                            color: #adadad;
                                            margin-bottom: 3px;
                                        }
                                    }
                                }

                                div.product-detail {
                                    flex-shrink: 0;

                                    i {
                                        cursor: pointer;

                                        &:hover {
                                            color: #089bab;
                                        }
                                    }
                                }
                            }
                        }

                        div.order-handle {
                            margin-top: 6px;
                            display: flex;
                            justify-content: flex-end;

                            > span.btnn {
                                background: #F44336;
                                font-size: 12px;
                                padding: 6px 10px;
                                color: #ffffff;
                                border-radius: 4px;
                                cursor: pointer;

                                &:hover {
                                    opacity: 0.9;
                                }

                                &:first-child {
                                    margin-right: 6px;
                                }
                            }
                        }
                    }
                }
            }

            div.message-alert {
                width: 100%;
                padding: 20px 0;
                background: #FFFFFF;
                position: absolute;
                bottom: -300px;
                left: 0;
                z-index: 9999;
                transition: bottom 0.3s linear;
                border-radius: 0 0 22px 22px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                &.active {
                    bottom: -52px;
                    transition: bottom 0.3s linear;
                }

                > .img {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 20px;

                    > img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                > .txt {
                    font-weight: bolder;
                    margin-bottom: 10px;
                }

                > .price {
                    font-weight: lighter;
                    font-size: 12px;
                }
            }
        }

        div.box-footer {
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            border-top: 1px solid #d9d9d9;
            box-sizing: border-box;

            > .menu-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                padding: 0 12px;

                > i {
                    font-size: 24px;
                    margin-bottom: 4px;
                }

                > span {
                    font-size: 12px;
                }

                &.active {
                    color: #089bab;
                }
            }
        }
    }
</style>
